export const tileGroupName = {
    Break: 'Break',
    EndBreak: 'End Break',
    WorkDay: 'Work Day',
    All: 'All',
    Recent: 'Recent',
    Unknown: 'Unknown',
} as const;
